import { AchOffsetAccountsModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../../shared';
import { CompanyAccount } from './company-account.entity';

export class AchOffsetAccounts extends DomainEntity<AchOffsetAccountsModelDto> {
    public createDefault(): this {
        throw new Error('Method not implemented.');
    }

    public get managedAccounts() {
        return this.dto.managedAccounts.map(account => new CompanyAccount(account));
    }

    public get nonManagedAccounts() {
        return this.dto.nonManagedAccounts.map(account => new CompanyAccount(account));
    }
}
